<div class="access-denied-container">
  <h2>Access Denied</h2>
  <p>You do not have the necessary permissions to view this page.</p>
  <p>If you are a business owner, please consider upgrading to a Business Plan to access these features.</p>
</div>

<style>
  .access-denied-container {
    max-width: 600px;
    margin: 4rem auto;
    padding: 2rem;
    border: 1px solid #ffc107;
    background-color: #fff3cd;
    color: #856404;
    border-radius: 8px;
    text-align: center;
  }
</style>
